import Axios from 'axios';
import { isExpiredSignedUrlResponse, parseS3ErrorResponse, type S3ErrorResponse } from '../io/s3ErrorResponse';

// Keeps only the S3 code and message: an ExpiredToken body echoes the session token.
export class PartPutHttpError extends Error {
  override readonly name = 'PartPutHttpError';
  readonly s3Error: S3ErrorResponse;

  constructor(statusCode: number | undefined, statusMessage: string | undefined, body: string) {
    super(`Could not put chunk: ${statusMessage} (${statusCode})`);
    this.s3Error = parseS3ErrorResponse(statusCode, body);
  }
}

export function isExpiredSignedUrlError(error: unknown): boolean {
  if (error instanceof PartPutHttpError) {
    return isExpiredSignedUrlResponse(error.s3Error);
  }
  if (Axios.isAxiosError(error) && error.response !== undefined) {
    const data: unknown = error.response.data;
    return typeof data === 'string' && isExpiredSignedUrlResponse(parseS3ErrorResponse(error.response.status, data));
  }
  return false;
}
